import { createContext } from 'react';
import type { Me } from './types';

export interface AuthState {
  me: Me | null;
  /** True until a stored session has been checked with the backend. */
  loading: boolean;
  signIn: (directoryToken: string) => Promise<void>;
  signOut: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);
